import { createStyles } from "antd-style";
const useStyles = createStyles(({ token }) => ({
  btn: {
    "width": "32px",
    "height": "32px",
    "borderRadius": "5px",
    "position": "relative",
    "userSelect": "none",
    "cursor": "pointer",
    "&:hover": { background: "rgba(0, 0, 0, 0.06)" },
    "> div": {
      "position": "absolute",
      "width": "16px",
      "height": "16px",
      "borderRadius": "2px",
      "fontSize": "10px",
      "display": "flex",
      "alignItems": "center",
      "justifyContent": "center",
      "> div": { transform: "scale(0.8)" }
    },
    "> div:nth-child(1)": {
      backgroundColor: token.colorPrimary,
      color: "white",
      top: "4px",
      left: "2px",
      zIndex: 1
    },
    "> div:nth-child(2)": {
      border: `1px solid ${token.colorPrimary}`,
      bottom: "4px",
      right: "2px",
      color: token.colorPrimary
    }
  }
}));
var style_default = useStyles;
export {
  style_default as default
};
